module.exports = __webpack_public_path__ + "img/truck-loading.6881d4be.svg";